import React, { useCallback, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import ActionPlanScreen from "../../screen/ActionPlanScreen"
import Send from "../../core/communication"
import swal from "sweetalert"
import { customToast } from "../../components/Toast"
import { useScope } from "../SelectProjectCompanyContainer"
import { getIds } from "../../core/utils/getIds"
import { sort } from "fast-sort"
import moment from "moment"
import { useSelector } from "react-redux"
import { exportPlanActions } from "../../core/utils/exports"

const filterBySearch = (item, searchTerm) => {
  const search = searchTerm.toLowerCase().trim()
  const title = item?.title?.toLowerCase()
  const producerName = item?.producerName?.toLowerCase()

  return title.includes(search) || producerName.includes(search)
}

export const filterActionArray = (data = [], filters = {}) => {
  let filtered = [...data]

  const searchTerm = filters?.search?.trim()

  if (searchTerm) {
    filtered = filtered.filter(item => filterBySearch(item, searchTerm))
  }

  if (filters.responsible?.value) {
    filtered = filtered.filter(item =>
      item.internal_responsible === filters.responsible.value ||
      item.external_responsible === filters.responsible.value
    )
  }

  if (Array.isArray(filters?.status) && filters.status.length > 0) {
    const selectedStatusIds = filters.status.map(project => project?.value).filter(Boolean)

    filtered = filtered.filter(item => selectedStatusIds.includes(item.status))
  }

  if (filters.tags?.value?.length) {
    const values = filters.tags.value
    filtered = filtered.filter(item => {
      let parsedTags = []

      if (Array.isArray(item.tags)) {
        parsedTags = item.tags
      } else if (typeof item.tags === 'string' && item.tags.trim().startsWith('[')) {
        try {
          parsedTags = JSON.parse(item.tags)
        } catch (err) {
          parsedTags = []
        }
      }

      return parsedTags.some(tag => values.includes(tag))
    })
  }

  if (Array.isArray(filters?.projects) && filters.projects.length > 0) {
    const selectedProjectIds = filters.projects.map(project => project?.value).filter(Boolean)

    filtered = filtered.filter(item => selectedProjectIds.includes(item.project))
  }

  if (filters.date && filters.date.includes('|')) {
    const [startDateStr, endDateStr] = filters.date.split('|').map(s => s.trim())

    const toYYYYMMDD = (date) => {
      const d = new Date(date)
      const year = d.getUTCFullYear()
      const month = String(d.getUTCMonth() + 1).padStart(2, '0')
      const day = String(d.getUTCDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    filtered = filtered.filter(item => {
      if (!item.start_at || !item.finish_at) return false

      const itemStartDate = toYYYYMMDD(item.start_at)
      const itemEndDate = toYYYYMMDD(item.finish_at)

      return itemStartDate >= startDateStr && itemEndDate <= endDateStr
    })
  }

  return filtered
}

export const statusOptions = [
  {
    value: "INPROGRESS",
    label: "Em andamento",
  },
  {
    value: "VALIDATION",
    label: "Em Validação",
  },
  {
    value: "FINISHED",
    label: "Finalizado",
  },
  {
    value: "NOTCOMPLETED",
    label: "Não concluído",
  },
  {
    value: "CANCELED",
    label: "Cancelado",
  },
]

const iaContextActivities = [
  {
    indicator: "Faz parte de Cooperativa de produtores? Qual o nome da Cooperativa?", //Exemplo de indicador presente na escala
    value: 30, //valor numérico de 0 a 100, representa a sustentabilidade do produtor naquele indicador
    isComplete: "2024-07-22T14:23:49.853Z", //Data para concluir a atividade
    title: "", //Titulo que representa a atividade
    email: "TESTE",
    instructions: "TESTE",
    //campos devem vir preenchidos e fazem parte da metologia 5W2H
    why: "TESTE",
    who: null,
    location: "TESTE",
    duration: null,
    eventId: null,
    projectId: null,
    start_at: "2024-07-23T00:00:00.000Z",
    finish_at: "2024-07-26T00:00:00.000Z",
    createdAt: "2024-07-22T14:23:44.754Z",
    updatedAt: "2024-07-22T14:23:44.754Z",
    deletedAt: null,
  },
]

const tabStatusOptions = [
  { value: 1, label: "Em andamento", field: "in_progress" },
  { value: 2, label: "Concluído", field: "complete" },
]

const loadAllTec = async (setTechnicalList, scopeType, projectsByScope) => {
  const formattedProjectsByScope = projectsByScope.map((row) => ({
    value: row?.id,
    label: row?.description,
  }))

  try {
    const response = await Send.get(
      "/users/tec-or-manager",
      `projects=${getIds(formattedProjectsByScope)}&scopeType=${scopeType}&role=manager`,
    )
    setTechnicalList(response.map((row) => ({ value: row?.id, label: row?.name })))
  } catch (error) {
    console.log("Error => ", error)
    customToast("Erro ao carregar técnicos", "error")
  }
}

const ActionPlanContainer = ({
  editedChatFields,
  handleEdit,
  handleSave,
  handleCancel,
  loadingField,
  onChangeQuestionsInfo,
  editIndex,
  handleActiveIndicator,
  formSteps,
  indicatorTabsOptions,
  indicators,

}) => {

  const { userId } = useParams()
  const { scopeType, scope, projectsByScope } = useScope()
  const { id: currentUserId } = useSelector(state => state?.app?.user?.user)

  const [loading, setLoading] = useState(false)
  const [loadingActionSave, setLoadingActionSave] = useState(false)
  const [loadingActionPlan, setLoadingActionPlan] = useState(false)
  const [actionPlan, setActionPlan] = useState([])
  // const [currentTab, setCurrentTab] = useState(tabStatusOptions[0] || {})
  const [values, setValues] = useState({})
  const [selectedIndicator, setSelectedIndicator] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [modalOpenEdit, setModalOpenEdit] = useState(false)
  const [modalOpenChat, setModalOpenChat] = useState(false)
  const [reloadActionPlan, setReloadActionPlan] = useState(false)
  const [technicalList, setTechnicalList] = useState([])
  const [filter, setFilter] = useState()
  const [tagPossibility, setTagPossibility] = useState([])
  const cacheFarmerState = useSelector((state) => state.app?.cacheFarmerState) || {}
  const [modalFilterIsOpen, setModalFilterIsOpen] = useState(false)

  const { exportPlan, loadingExport } = exportPlanActions(
    filterActionArray(actionPlan, filter),
    "plan_actions_",
  )

  useEffect(() => {
    handleActiveIndicator(indicatorTabsOptions[0])
    if (modalOpen) {
      loadAllTec(setTechnicalList, scopeType, projectsByScope)
    }
  }, [modalOpen])

  useEffect(() => {
    if (userId) {
      loadActionPlan()
    }
  }, [userId])

  const loadActionPlan = useCallback(async () => {
    try {
      setLoadingActionPlan(true)
      const response = await Send.get(
        `/scale-action/all-action-profile/${userId}`,
        cacheFarmerState?.fromUsers || cacheFarmerState?.fromChat
          ? `projects='${cacheFarmerState?.fromUsers?.projectId || cacheFarmerState?.fromChat?.projectId
          }'`
          : ``,
        // `type=${`${currentTab?.field}` || `in_progress`}`,
      )

      // console.log("$%%", response)

      const formatted = sort(response).by([
        { asc: (u) => typeof u.isComplete === "string" },
        { asc: (u) => u.finish_at },
      ])
      const formattedCaseSoyProject =
        projectsByScope[0]?.id === "1540697b-397c-4a25-80eb-e957ef61b523"
          ? formatted.map((item) => ({ ...item, finish_at: null }))
          : formatted
      setActionPlan(
        formattedCaseSoyProject.map((item) =>
          item?.tags ? { ...item, tags: JSON.parse(item.tags) } : { ...item, tags: [] },
        ),
      )
      const tags = formatted.filter((item) => item?.tags).map((item) => JSON.parse(item?.tags))
      const output = tags.flatMap((item) => JSON.parse(item).map((str) => str.trim()))
      const unique = _.uniq(output)
      setTagPossibility(unique)
    } catch (error) {
      console.log("Error", error)
      customToast("Erro ao buscar ações", "error")
    } finally {
      setLoadingActionPlan(false)
    }
  }, [userId])

  useEffect(() => {
    if (reloadActionPlan) {
      loadActionPlan()
      setReloadActionPlan(false)
    }

    ; () => setReloadActionPlan(false)
  }, [reloadActionPlan, loadActionPlan])

  const reload = () => {
    setReloadActionPlan(true)
  }

  // const handleActiveStatus = (value) => {
  //   setCurrentTab(value)

  //   if (value.field === "planning") {
  //     generatePlan(false)
  //   }
  // }

  const generatePlan = async (hasContext) => {
    setLoading(true)
    try {
      let message = ""
      if (hasContext) {
        await swal({
          title: "Detalhe seu plano de ação",
          content: {
            element: "textarea",
            attributes: {
              id: "textarea-input",
              className: "swal-content__textarea",
              style: "width: 100%; height: 150px;",
              placeholder: "De que forma podemos direcionar o plano de ação...",
            },
          },
          buttons: {
            cancel: "Ignorar",
            confirm: {
              text: "Confirmar",
              closeModal: false,
            },
          },
          preConfirm: () => {
            const text = document.getElementById("textarea-input").value
            if (!text) {
              swal.showValidationMessage("Você precisa escrever algo!")
              return false
            }
            return text
          },
        })

        message = document.getElementById("textarea-input").value

        swal.close()
      }

      const context = `Possuímos uma escala de sustentabilidade. Esta escala utiliza uma nota de 0 a 100 para cada indicador e separa os indicadores em dimensões, temos a nota de sustentabilidade considerando os pesos de cada dimensão. Para a cooperativa atual, segue o JSON referente a escala: ${JSON.stringify(
        indicators,
      )}
        
      Considerando que você é um especialista em agronomia e irá auxiliar outros especialistas respondendo como ele pode melhorar sustentabilidade dessa cooperativa, responda a próxima pergunta, utilize JSON para responder, de acordo com o modelo:
      ${JSON.stringify(iaContextActivities)}
      
      ${message
          ? `Considere também minha observação antes de gerar o plano de ação: ${message}`
          : ""
        }
      `
      const response = await Send.post("/ia/ask", {
        question: `Gere um plano de ação em JSON para melhorar a sustentabilidade dessa cooperativa. Considere os indicadores que estão críticos e que precisam de atenção. Coloque datas apartir da data atual. O valor do indicador, precisa ser o mesmo do JSON de indicadores repassado, foque na melhoria nesses pilares.`,
        context,
      })

      if (response && response.message && response.message.content) {
        // Usando regex para extrair o JSON do texto
        const jsonStringMatch = response.message.content.match(/```json\s*([\s\S]*?)\s*```/)

        if (!jsonStringMatch || jsonStringMatch.length < 2) {
          throw new Error("Formato de JSON não encontrado no texto")
        }

        const jsonString = jsonStringMatch[1]
        const result = JSON.parse(jsonString)
        // setCurrentTab(tabStatusOptions[0])
        setActionPlan(result)
      }
    } catch (e) {
      console.log({ e })
    }
    setLoading(false)
  }

  const onChangeValues = (event) => {
    const { value, name } = event.target
    console.log("event -> ", { value, name })
    setValues((curr) => ({ ...curr, [name]: value }))
  }

  const handleSaveAction = async () => {
    try {
      setLoadingActionSave(true)
      /* if (
        !values?.email ||
        !values?.title ||
        !values?.finish_at ||
        !values?.start_at ||
        !values?.location ||
        !values?.why ||
        !values?.instructions
      ) {
        customToast("Você deve preencher todos os campos!", "warning")
        return
      } */

      const dataToUpdate = {
        title: values?.title,
        reviewer: values?.reviewer?.value,
        selectedIndicator,
        projectId: cacheFarmerState?.fromUsers?.projectId || scope?.id,
        createdBy: currentUserId,
        details: {
          email: values?.internal_responsible,
          external_responsible: values?.external_responsible,
          finish_at: values?.finish_at || moment().format("YYYY-MM-DD"),
          start_at: values?.start_at || moment().format("YYYY-MM-DD"),
          location: values?.location,
          why: values?.why,
          instructions: values?.instructions,
          status: values?.status || null,
        },
        producerId: userId,
        comments: values?.comments || null,
      }

      const response = await Send.post("/scale-action/farmer-profile", dataToUpdate)

      if (response?.status !== "success") {
        throw new Error("Erro ao salvar as ações")
      }

      customToast("Ação salva", "success")
      setModalOpen(false)
    } catch (error) {
      console.log("Error ", error)
      customToast("Erro ao salvar ações", "error")
    } finally {
      setLoadingActionSave(false)
      setReloadActionPlan(true)
    }
  }

  const handleSelectedIndicator = (currentIndicator) => {
    setSelectedIndicator(currentIndicator)
  }

  const handleOpenChatModal = () => {
    setModalOpenChat(true)
  }

  const changeFilter = (field, value) => {
    setFilter((old) => ({ ...old, [field]: value }))
  }

  const emails = actionPlan
    .filter(
      (item) =>
        item?.internal_responsible?.includes("@") || item?.external_responsible?.includes("@"),
    )
    .map(({ external_responsible, internal_responsible }) => ({
      label: external_responsible || internal_responsible,
      value: external_responsible || internal_responsible,
    }))
  const uniqueEmails = _.uniqBy(emails, "value")

  return (
    <ActionPlanScreen
      {...{
        data: filterActionArray(actionPlan, filter),
        formSteps,
        tabStatusOptions,
        indicatorTabsOptions,
        indicators,
        editedChatFields,
        values,
        handleEdit,
        handleSave,
        handleCancel,
        loadingField,
        onChangeQuestionsInfo,
        editIndex,
        generatePlan,
        loading,
        loadingActionSave,
        loadingActionPlan,
        // currentTab,
        handleSaveAction,
        onChangeValues,
        handleSelectedIndicator,
        modalOpen,
        setModalOpen,
        technicalList,
        changeFilter,
        uniqueEmails,
        filter,
        tagPossibility,
        setTagPossibility,
        handleActiveIndicator,
        modalOpenEdit,
        reload,
        exportPlan,
        statusOptions,
        setModalFilterIsOpen,
        modalFilterIsOpen,
        handleOpenChatModal,
        modalOpenChat,
        setModalOpenChat
      }}
    />
  )
}

export default ActionPlanContainer
